import { useEffect, useState, useCallback } from "react";

export const useSmartBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const isClosed = localStorage.getItem("smartBannerClosed");
    if (!isClosed) {
      setIsVisible(true);
    }
  }, []);

  const handleClose = useCallback(() => {
    setIsVisible(false);
    localStorage.setItem("smartBannerClosed", "true");
  }, []);

  return { isVisible, handleClose };
};
